module.exports = __webpack_public_path__ + "img/WP1_CrystalSword.80fbf804.png";